"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorNoFocus = 'rgba(0, 0, 0, 0.54)';
exports.colorFocus = '#303f9f';
exports.colorHover = '#000000';
exports.colorClearNormal = '#ff4040';
exports.colorClearHover = '#d00000';
//# sourceMappingURL=ColorConstants.js.map